import React, { useRef, useState, useEffect } from 'react';
import './style.css';
import { useLocation } from 'react-router-dom';

const AuraTrustedSlider = ({ hideTrusted, heading, showGoogleIcons, category }) => {
    const [startScroll, setStartScroll] = useState(false);
    const sliderRef = useRef(null);
    const [animationDuration, setAnimationDuration] = useState("70s");

    const SCROLL_SPEED = 40; // pixels per second (adjust this to your liking)

    const clientLogos = [
        { src: "/images/client-logo/eclinicalworks.png", alt: "eclinicalworks", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/ocean.png", alt: "ocean", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/veradigm.png", alt: "veradigm", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/allscript.png", alt: "all script", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/nextgen.png", alt: "next gen", width: 120, category: "auraclinic" },
        { src: "/images/client-logo/athenahealtch.png", alt: "athenahealth", width: 150, category: "auraclinic" },
        { src: "/images/client-logo/openemr.png", alt: "open EMR", width: 150, category: "auraclinic" },
    ];

    const sdkLogos = ["Google", "Vercel", "AWS", "Mirco Soft", "Resume Yawk", "Pharma", "Netexam", "Azure", "Patrick"];

    let filteredLogos = showGoogleIcons
        ? clientLogos
        : clientLogos.filter(logo => !sdkLogos.includes(logo.alt));

    if (category) {
        filteredLogos = filteredLogos.filter(logo => logo.category === category);
    }

    const location = useLocation();
    const homePaths = ["/", "/us", "/ksa", "/au", "/uae"];
    const isHomePage = homePaths.includes(location.pathname);

    useEffect(() => {
        const handleScroll = () => {
            setStartScroll(window.scrollY >= 100);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // ✅ Dynamically calculate animation duration
    useEffect(() => {
        if (sliderRef.current) {
            const totalWidth = sliderRef.current.scrollWidth / 2; // half because you duplicate logos
            const duration = totalWidth / SCROLL_SPEED; // seconds
            setAnimationDuration(`${duration}s`);
        }
    }, [filteredLogos]);

    return (
        <>
            {!isHomePage && !hideTrusted && (
                <div className="aura-grey-bg-box pt-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="trusted-main-heading">
                                    {heading || "We're Trusted By:"}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="trusted-partners-main-box">
                <div className="container">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="client-logo-slider-wrapper overflow-hidden mt-3">
                                <div
                                    ref={sliderRef}
                                    className={`client-logo-slider-box flex ${startScroll ? "animate-scroll" : ""}`}
                                    style={{
                                        animationDuration: animationDuration,
                                    }}
                                >
                                    {filteredLogos.concat(filteredLogos).map((logo, index) => (
                                        <img
                                            key={index}
                                            className="trusted-logo-images"
                                            src={logo.src}
                                            alt={logo.alt}
                                            width={logo.width || 100}
                                            height={60}
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AuraTrustedSlider;